import openPopupOperation from 'editor/src/store/app/module/popup/operation/openPopupOperation';
import type { Thunk } from 'editor/src/store/hooks';

import { translateOr } from 'editor/src/util/useTr';

import { PopupName } from 'editor/src/component/Popup/popups';

// The question every path that drops pages holding the user's content asks first, so a delete from
// the spread menu and a smaller page count picked among the variants read the same.
const confirmContentPagesRemovalOperation =
  (pages: number, onConfirm: () => void, onCancel?: () => void): Thunk =>
  (dispatch, getState, { i18n }) => {
    dispatch(
      openPopupOperation(PopupName.LOCAL_CONFIRMATION_POPUP, {
        popupTitle: i18n.t('editor-delete-pages-confirm-count', { count: pages }),
        // An empty page goes without a question, so the dialog has to say why this one asks.
        textLines: [
          translateOr(i18n.t, 'editor-delete-pages-content-warning', 'These pages hold your photos or text.'),
        ],
        options: [
          { title: i18n.t('editor-cancel'), onConfirm: onCancel },
          { title: i18n.t('editor-delete-pages-count', { count: pages }), onConfirm },
        ],
        hideTitleIcon: true,
        onCancel,
      }),
    );
  };

export default confirmContentPagesRemovalOperation;
